<template>
  <div class="flex items-center space-x-2">
    <RouterLink :to="toRoute" class="inline-flex text-indigo-600 hover:text-indigo-900">
      View
    </RouterLink>
    <Dropdown ref="dropdown">
      <template #button="{ open }">
        <button
          type="button"
          class="p-2 rounded-full bg-transparent hover:bg-gray-200 focus:outline-none"
          @click="open"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <circle cx="12" cy="12" r="1" />
            <circle cx="12" cy="19" r="1" />
            <circle cx="12" cy="5" r="1" />
          </svg>
        </button>
      </template>

      <div
        class="origin-top-right absolute right-0 mt-2 max-w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <OrderListItemSoftOneActionsGroup
          :order="order"
          :softone-api-services="softoneApiServices"
          :third-party-service-documents="thirdPartyServiceDocuments"
        />
      </div>
    </Dropdown>
  </div>
</template>

<script>
import OrderListItemSoftOneActionsGroup from './order-list-item-softone-actions-group.vue';

export default {
  components: {
    OrderListItemSoftOneActionsGroup,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    softoneApiServices: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    thirdPartyServiceDocuments() {
      return (this.order?.thirdPartyServiceDocuments || [])
        .map((idOrObj) => {
          if (typeof idOrObj === 'string') {
            return this.$store.state.entities.thirdPartyServiceDocuments.byId[idOrObj];
          }

          return idOrObj;
        })
        .filter((x) => x);
    },
    toRoute() {
      return {
        name: 'accounts.accountId.accOrders.accOrderId',
        params: {
          accountId: this.accountId,
          accOrderId: this.order.id,
        },
      };
    },
  },
};
</script>
